<template>
	<div class="footDesc">
		<van-nav-bar v-if="isMobile" :title="$t('footer.gmRules')" left-arrow @click-left="onClickLeft" />
		<div class="ruleCon">
			<p>{{ $t('footer.levelTips', { nums: nums }) }}</p>
			<p>{{ $t('footer.ruleTips1') }}</p>
			<p>{{ $t('footer.ruleTips2') }}</p>
			<p>{{ $t('footer.ruleTips3') }}</p>
			<p>{{ $t('footer.ruleTips4') }}</p>
			<p>{{ $t('footer.ruleTips5') }}</p>
		</div>
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed } from 'vue'
	import { useRoute,useRouter } from 'vue-router';
	import useConfigStore from '@/store/modules/config'
	
	const { proxy } = getCurrentInstance();
	const router = useRouter();
	const content = ref('')
	const nums = ref('977,815,269')
	
	const isMobile = computed(() => {
		return useConfigStore().isMobile
	})
	
	onMounted(() => {
		
	})
	const onClickLeft = () => {
		history.back()
	}
</script>

<style lang="less" scoped>
	.ruleCon{
		width: 100%;padding: 1rem;box-sizing: border-box;font-size: 0.875rem;
		p{
			margin: 0.5rem 0;
		}
	}
</style>